/**
 * NewMissionPage
 *
 * Main mission planning page with waypoint management
 */

import { useState } from 'react';
import { Viewer as CesiumViewer } from 'cesium';
import { useViewer } from '@/contexts/ViewerContext';
import { MissionToolbar } from '@/features/mission/components/MissionToolbar';
import { MissionPlanner } from '@/features/mission/components/MissionPlanner';
import MapViewer from '@/features/map/components/CesiumViewer';
import { MapControls } from '@/features/map/components/MapControls';
import { MissionInfoPanel } from '@/features/mission/components/MissionInfoPanel';

export function NewMissionPage() {
  const contextViewer = useViewer().viewer;
  const [viewer, setViewer] = useState<CesiumViewer | undefined>(contextViewer);
  const [isListVisible, setIsListVisible] = useState(true);
  const [selectedMapType, setSelectedMapType] = useState('1');


  const handleViewerReady = (cesiumViewer: CesiumViewer) => {
    setViewer(cesiumViewer);
  };

  const handleMapTypeChange = (mapType: string) => {
    setSelectedMapType(mapType);
  };

  return (
    <div className="h-full w-full relative bg-slate-950 overflow-hidden">
      {/* Mission Toolbar */}
      <div
        className="absolute top-0 left-2 pointer-events-auto"
        style={{
          right: 'calc(25.3rem)'
        }}
      >
        <MissionToolbar viewer={viewer} />
      </div>

      {/* Map Viewer */}
      <div
        className="absolute top-16 left-4 pointer-events-auto bg-slate-900/95 backdrop-blur-sm border border-slate-700 rounded-lg shadow-2xl overflow-hidden flex flex-col"
        style={{
          right: 'calc(24rem + 1rem + 1rem)',
          bottom: 'calc(25% + 1rem)'
        }}
      >
        <div className="flex-1 relative bg-slate-800 rounded overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-slate-700 via-slate-800 to-slate-900">
            <MapViewer onViewerReady={handleViewerReady} selectedMapType={selectedMapType} />
            <MapControls viewer={viewer} selectedMapType={selectedMapType} onMapTypeChange={handleMapTypeChange} />
          </div>
        </div>
      </div>

      {/* Right Panel - Drone Feed & Mission Details (Independent) */}
      <div
        className="absolute top-4 right-4 w-96 pointer-events-auto flex flex-col"
        style={{ bottom: '1rem' }}
      >
        <MissionInfoPanel />
      </div>

      {/* Mission Planner (Waypoint List + Stats) */}
      <div 
        className="absolute left-4 pointer-events-auto"
        style={{
          right: 'calc(24rem + 1rem + 1rem)',
          bottom: '1rem',
          height: '25%'
        }}
      >
        <MissionPlanner viewer={viewer} isListVisible={isListVisible} setIsListVisible={setIsListVisible} />
      </div>
    </div>
  );
}